'use strict';

module.exports = function(posA, posB) {
	return posB - posA;
};
